import styled from 'styled-components';

export const QuickConfigsList = styled.div`
  border: 0.5px solid ${Styles.color.grey.four};
  border-radius: 0.25rem;
  display: flex;
  height: 4rem;
  margin: 2rem 0;

  > div:not([disabled]):hover {
    cursor: pointer;
  }

  > div:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
  }

  > div:last-child {
    border-bottom-right-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  > div:not(:last-child) {
    border-right: inherit;
  }
`;
